export default __webpack_public_path__ + "static/media/service_details_one.4c9961c4.png";